import React, { useState } from 'react';
import { logCrmEvent } from '@javascripts/util/eventLogging';
import Icons from '@components/shared/icons';
import Fetch from '@components/util/Fetch';
import Modal from '../ProfileV2/shared/Modal';

import './styles.scss';

const EMAIL_TEMPLATES_PATH = '/profile/account-settings/email-templates';

const CustomEmailTemplateModal = () => {
  const [isOpen, setIsOpen] = useState(true);

  const dismiss = () => {
    logCrmEvent('disruptor_dismissed', { type: 'custom_email_template' });
    Fetch.post({ url: '/profile/account_settings/custom_email_template_disruptor_dismissed' });
    setIsOpen(false);
  };

  const submit = () => {
    logCrmEvent('disruptor_accepted', { type: 'custom_email_template' });
    window.location = EMAIL_TEMPLATES_PATH;
  };

  return (
    <Modal
      close={dismiss}
      id="custom-email-template-modal"
      status={isOpen ? 'active' : 'hidden'}
    >
      <div className="custom-email-template-modal edit-modal-inner">
        <button
          type="button"
          className="close-button"
          onClick={dismiss}
        >
          <Icons type="close" />
        </button>
        <div className="custom-email-template-banner margin-bottom-24">
          <div className="custom-email-template-banner-label">
            <span className="custom-email-template-pill subheader">NEW FEATURE</span>
            <p className="custom-email-template-text headline-2">
              Contact Referrals Faster with QuickConnect Email Templates
            </p>
          </div>
          <Icons
            type="mail-ai"
            width={80}
            height={80}
            className="custom-email-template-banner-icon"
          />
        </div>
        <p className="custom-email-template-text large-slim-font margin-bottom-24">
          Draft reusable buyer and seller intro templates right in your account.
          Quickly customize your message,&nbsp;
          <b>add your go-to marketing attachments,</b>
          {' '}
          and fire off your outreach in just two clicks.
        </p>
        <div className="button-container">
          <button
            type="button"
            className="profile-edit-button submit"
            onClick={submit}
          >
            <Icons
              type="mail"
              width={24}
              height={24}
            />
            Create a QuickConnect Template
          </button>
          <button
            type="button"
            className="profile-edit-button highlighted"
            onClick={dismiss}
          >
            I'll Do This Later
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CustomEmailTemplateModal;
